<template>
  <div>
        <!-- ▼共通ヘッダー  -->
        <Header />
        <div class="main_cont">
            <div class="present_cont">
                <img class="pc" src="./assets/img/pc/present.png" alt="抽選で総計50名様にプレゼント Myユンケルを投票して景品をゲットしよう！ ワイヤレス充電器 抽選で20名様、オリジナルコインバンク 抽選で30名様 ※球団は選べません">
                <img class="sp" src="./assets/img/sp/present.png" alt="抽選で総計50名様にプレゼント Myユンケルを投票して景品をゲットしよう！ ワイヤレス充電器 抽選で20名様、オリジナルコインバンク 抽選で30名様 ※球団は選べません">
            </div>
            <!-- /.present_cont -->
            <div class="camp_cont">
                <h2 class="wrapper">
                    <img class="pc" src="./assets/img/pc/2camp.png" alt="2つのキャンペーン参加方法">
                    <img class="sp" src="./assets/img/sp/2camp.png" alt="2つのキャンペーン参加方法">
                </h2>
                <ul class="camp_how">
                    <li>
                        <img class="pc" src="./assets/img/pc/camp01_bg.png" alt="自分にぴったりのユンケルを探して投票したい方はこちらをクリック">
                        <img class="sp" src="./assets/img/sp/camp01_bg.png" alt="自分にぴったりのユンケルを探して投票したい方はこちらをクリック">
                        <a href="#find"><img src="./assets/img/pc/find_btn.png" alt="Myユンケルを見つけるへ"></a>
                    </li>
                    <li>
                        <img class="pc" src="./assets/img/pc/camp02_bg.png" alt="すでに投票したいユンケルが決まっている方はこちらをクリック">
                        <img class="sp" src="./assets/img/sp/camp02_bg.png" alt="すでに投票したいユンケルが決まっている方はこちらをクリック">
                        <a href="#lineup"><img src="./assets/img/pc/lineup_btn.png" alt="LINE UPへ"></a>
                    </li>
                </ul>
                <!-- /.camp_how -->
            </div>
            <!-- /.camp_cont -->
            <div class="find_cont" id="find">
                <!-- class="q"追加でタイトル切り替え -->
                <div class="ttl" v-bind:class='{q:isActive01}'>
                    <span class="border pc"></span><!-- /.border -->
                    <h2>
                        <img class="pc" src="./assets/img/find_ttl.png" alt="Myユンケルを見つける">
                        <img class="sp" src="./assets/img/sp/find_ttl.png" alt="Myユンケルを見つける">
                    </h2>
                    <h2>
                        <img class="pc" src="./assets/img/pc/find_ttl_q.png" alt="Myユンケルを見つける">
                        <img class="sp" src="./assets/img/sp/find_ttl_q.png" alt="Myユンケルを見つける">
                    </h2>
                    <span class="border pc"></span><!-- /.border -->
                </div>
                <!-- /.ttl -->
                <!-- class="q"追加で非表示 -->
                <div class="situation_ttl" v-bind:class='{q:isActive01}'>
                    <img class="pc" src="./assets/img/pc/scene_q_ttl.png" alt="あなたはどんなときに栄養ドリンクを飲みたいですか？">
                    <img class="sp" src="./assets/img/sp/scene_q_ttl.png" alt="あなたはどんなときに栄養ドリンクを飲みたいですか？">
                </div>
                <!-- /.situation_ttl -->
                <div class="check_cont">
                    <transition name="fade" mode="out-in">
                      <div key="q0" class="opening wrapper" v-if="questionNumber == 0">
                          <img class="pc bg" src="./assets/img/pc/scene_q_img.png" alt="自分のスイッチを入れたいとき,パフォーマンスアップのため,疲れているとき,食欲がないとき,かぜを引いたとき">
                          <img class="sp bg" src="./assets/img/sp/scene_q_img.png" alt="自分のスイッチを入れたいとき,パフォーマンスアップのため,疲れているとき,食欲がないとき,かぜを引いたとき">
                          <a class="btn check" v-on:click="isActive01=true; answerQuestion(1)"><img src="./assets/img/check_btn.png" alt="チェックする"></a>
                      </div>
                      <div key="q1" class="question wrapper q3" v-else-if="questionNumber == 1">
                          <div class="q_btn pc" v-for="(value, key) in shuffle(questions[1])" :key="key" v-on:click='answerQuestion(`${value.num}`, 1); isShowBack=true'>
                              <div v-html="value.text"></div>
                          </div>
                          <div class="q_btn sp" v-for="(value, key) in shuffle(questions_sp[1])" :key="key" v-on:click='answerQuestion(`${value.num}`, 1); isShowBack=true'>
                              <div v-html="value.text"></div>
                          </div>
                      </div>
                      <div key="q2" class="question wrapper q2" v-else-if="questionNumber == 2">
                          <div class="q_btn pc" v-for="(value, key) in shuffle(questions[2])" :key="key" v-on:click='answerQuestion(`${value.num}`, 2)'>
                              <div v-html="value.text"></div>
                          </div>
                          <div class="q_btn sp" v-for="(value, key) in shuffle(questions_sp[2])" :key="key" v-on:click='answerQuestion(`${value.num}`, 2)'>
                              <div v-html="value.text"></div>
                          </div>
                      </div>
                      <div key="q3" class="question wrapper q4" v-else-if="questionNumber == 3">
                          <div class="q_btn pc" v-for="(value, key) in shuffle(questions[3])" :key="key" v-on:click='openResult(`${value.num}`)'>
                              <div v-html="value.text"></div>
                          </div>
                          <div class="q_btn sp" v-for="(value, key) in shuffle(questions_sp[3])" :key="key" v-on:click='openResult(`${value.num}`)'>
                              <div v-html="value.text"></div>
                          </div>
                      </div>
                      <div key="q4" class="question wrapper q4" v-else-if="questionNumber == 4">
                          <div class="q_btn pc" v-for="(value, key) in shuffle(questions[4])" :key="key" v-on:click='openResult(`${value.num}`)'>
                              <div v-html="value.text"></div>
                          </div>
                          <div class="q_btn sp" v-for="(value, key) in shuffle(questions_sp[4])" :key="key" v-on:click='openResult(`${value.num}`)'>
                              <div v-html="value.text"></div>
                          </div>
                      </div>
                      <div key="q5" class="question wrapper q4" v-else-if="questionNumber == 5">
                          <div class="q_btn pc" v-for="(value, key) in shuffle(questions[5])" :key="key" v-on:click='openResult(`${value.num}`)'>
                              <div v-html="value.text"></div>
                          </div>
                          <div class="q_btn sp" v-for="(value, key) in shuffle(questions_sp[5])" :key="key" v-on:click='openResult(`${value.num}`)'>
                              <div v-html="value.text"></div>
                          </div>
                      </div>
                      <div key="q6" class="question wrapper q3" v-else-if="questionNumber == 6">
                          <div class="q_btn pc" v-for="(value, key) in shuffle(questions[6])" :key="key" v-on:click='openResult(`${value.num}`)'>
                              <div v-html="value.text"></div>
                          </div>
                          <div class="q_btn sp" v-for="(value, key) in shuffle(questions_sp[6])" :key="key" v-on:click='openResult(`${value.num}`)'>
                              <div v-html="value.text"></div>
                          </div>
                      </div>
                    </transition>
                    <transition name="fade" mode="out-in">
                      <div class="link_cont back" style="justify-content: center; display: flex;" v-if="isShowBack == true">
                        <a v-on:click='answerQuestion(`${backNum}`, 1)'><span class="back">1つ前に戻る</span></a>
                      </div><!-- /.link_cont -->
                    </transition>
                    <div class="bottom_border">
                    </div>
                    <!-- /.bottom_border -->
                </div>
                <!-- /.check_cont -->
            </div>
            <!-- /#find.find_cont -->
            <LineUp />
            <!-- /#lineup.lineup_cont -->
            <Detail />
            <!-- /.detail_cont -->
            <ApplicationOverview />
            <!-- /.offer_cont -->
            <div class="link_cont">
                <a target="_blank" href="https://www.sato-seiyaku.co.jp/"><span>佐藤製薬サイトへ戻る</span></a>
                <a target="_blank" href="https://www.yunker.jp/"><span>ユンケルブランドサイトへ戻る</span></a>
            </div>
            <!-- /.link_cont -->
            <!-- モーダル -->
            <transition name="fade2">
                <div key="result" class="modal_cont" v-show="isShowResult">
                    <div class="find_cont">
                        <!-- class="q"追加でタイトル切り替え -->
                        <div class="ttl" v-bind:class='{q:isActive01}'>
                            <span class="border pc"></span><!-- /.border -->
                            <h2>
                                <img class="pc" src="./assets/img/find_ttl.png" alt="Myユンケルを見つける">
                                <img class="sp" src="./assets/img/sp/find_ttl.png" alt="Myユンケルを見つける">
                            </h2>
                            <h2>
                                <img class="pc" src="./assets/img/pc/find_ttl_q.png" alt="Myユンケルを見つける">
                                <img class="sp" src="./assets/img/sp/find_ttl_q.png" alt="Myユンケルを見つける">
                            </h2>
                            <span class="border pc"></span><!-- /.border -->
                        </div>
                        <!-- /.ttl -->
                        <!-- class="q"追加で非表示 -->
                        <div class="situation_ttl" v-bind:class='{q:isActive01}'>
                            <img class="pc" src="./assets/img/pc/scene_q_ttl_modal.png" alt="あなたにピッタリのユンケルは…">
                            <img class="sp" src="./assets/img/sp/scene_q_ttl_modal.png" alt="あなたにピッタリのユンケルは…">
                        </div>
                        <!-- /.situation_ttl -->
                        <div class="result_cont wrapper">
                            <div class="img_cont">
                                <img class="pc" alt="" v-bind:src='`./img/products/pc/${products[productId].img}`'>
                                <img class="sp" alt="" v-bind:src='`./img/products/sp/${products[productId].img}`'>
                            </div>
                            <!-- /.img_cont -->
                            <div class="txt_cont">
                                <p class="genre">
                                    <img src="./assets/img/genre.png" alt="">
                                </p>
                                <!-- /.genre -->
                                <dl class="result_ttl">
                                    <dt>＜ {{ products[productId].copy }} ＞</dt>
                                    <dd v-bind:class="products[productId].css">{{ products[productId].name }}</dd>
                                </dl>
                                <!-- /.ttl -->
                                <p class="lead">
                                    <img src="./assets/img/pc/result_deco_line.png" alt="">
                                    <span class="main">{{ products[productId].content }}</span><!-- /.main -->
                                    <br>
                                    <span class="merit">
                                    効能：{{ products[productId].efficacy }}
                                    </span><!-- /.merit -->
                                    <img src="./assets/img/pc/result_deco_line.png" alt="">
                                </p>
                                <!-- /.lead -->
                                <a target="_blank" class="result_vote" v-bind:href='`${formUrl}${products[productId].id}`'><img src="./assets/img/pc/result_vote_btn.png" alt=""></a><!-- /.result_vote -->
                            </div>
                            <!-- /.txt_cont -->
                        </div>
                        <!-- /.result_cont -->
                        <div class="check_cont">
                            <!-- class="q"追加で非表示 -->
                            <div class="bottom_border" v-bind:class='{q:isActive01}'>
                            </div>
                            <!-- /.bottom_border -->
                        </div>
                        <!-- /.check_cont -->
                    </div>
                    <!-- /.find_cont -->
                    <div class="close_btn" v-on:click='isShowResult=false; isActive01=false; questionNumber=0'>
                        <img src="./assets/img/close_btn.png" alt="">
                    </div>
                    <!-- /.close_btn -->
                </div>
            </transition>
            <!-- /.modal_cont -->
        </div>
        <footer>
            <p class="wrapper">&copy; SATO PHARMACEUTICAL CO.,LTD. Allright Reserved.</p>
            <p class="wrapper"><img src="./assets/img/mbl_logo.png" alt="">Major League Baseball trademarks and copyrights are used with permission of Major League Baseball. Visit MLB.com.</p>
        </footer>
      </div>
</template>

<script>
import products from './assets/data.json'
import questions from './assets/data_q.json'
import questions_sp from './assets/data_q_sp.json'
import Header from './components/Header'
import LineUp from './components/LineUp'
import Detail from './components/Detail'
import ApplicationOverview from './components/ApplicationOverview'
export default {
  name: 'App',
  data(){
    return {
      questionNumber: 0,
      isActive01: false,
      isShowResult: false,
      products: products,
      productId: 0,
      formUrl: "https://yunker.sato-cp.jp/senkyo_2020/?product=",
      questions: questions,
      questions_sp: questions_sp,
      isShowBack: false,
      backNum: 0
    }
  },
  components: {
    Header,
    LineUp,
    Detail,
    ApplicationOverview
  },
  updated () {
    window.Ts.loadFont()
  },
  methods: {
    answerQuestion: function (num, backNum) {
      this.questionNumber = num
      this.backNum = backNum
      if (this.questionNumber == 1) {
        this.isShowBack = false
      }
    },
    openResult: function (id) {
      this.isShowResult = true
      this.productId = id
      this.isActive01 = false
      this.isShowBack = false
    },
    shuffle: function(array) {
      for (let i = array.length - 1; i > 0; i--) {
        let r = Math.floor(Math.random() * (i + 1))
        let tmp = array[i]
        array[i] = array[r]
        array[r] = tmp
      }
      return array
    }
  }
}
</script>

<style>
/* フェードイン */
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}
.fade-enter {
  opacity: 0.3;
}
.fade-leave-to {
  opacity: 0;
}

.fade2-enter-active {
  transition: opacity .6s ease-out;
}
.fade2-leave-active {
  transition: opacity .6s ease-in;
}
.fade2-enter {
  opacity: 0.3;
}
.fade2-leave-to {
  opacity: 0;
}

.small {
  font-size: 34px !important;
}


@charset "UTF-8";
/*************共通項目など*************/
/* Windows 用 Medium 指定の游ゴシック */
@font-face {
  font-family: "Yu Gothic M";
  src: local("Yu Gothic Medium");
}

/* font-weight: bold の時は通常どおり Bold 書体を使わせる */
@font-face {
  font-family: "Yu Gothic M";
  src: local("Yu Gothic Bold");
  font-weight: bold;
}

body {
  font-family: "游明朝", YuMincho, "Hiragino Mincho ProN W3", "ヒラギノ明朝 ProN W3", "Hiragino Mincho ProN", "HG明朝E", "ＭＳ Ｐ明朝", "ＭＳ 明朝", serif;
  color: #000;
  background: #072b61;
  /* Old browsers */
  /* FF3.6-15 */
  /* Chrome10-25,Safari5.1-6 */
  background: -webkit-gradient(linear, left top, right top, from(#072b61), color-stop(15%, #0a3c8c), color-stop(85%, #0a3c8c), to(#072b61));
  background: linear-gradient(to right, #072b61 0%, #0a3c8c 15%, #0a3c8c 85%, #072b61 100%);
  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#072b61', endColorstr='#072b61',GradientType=1 );
  /* IE6-9 */
  min-width: 1200px;
}

@media (max-width: 600px) {
  body {
    width: 100%;
    min-width: 100%;
  }
}

a {
  text-decoration: none;
  -webkit-transition: .2s ease-in-out;
  transition: .2s ease-in-out;
}

a:after, a:before {
  -webkit-transition: .2s ease-in-out;
  transition: .2s ease-in-out;
}

.wrapper {
  margin: 0 auto;
}

@media (max-width: 600px) {
  .wrapper {
    width: 94% !important;
  }
}

.pc {
  display: block;
}

@media (max-width: 600px) {
  .pc {
    display: none;
  }
}

.sp {
  display: none;
}

@media (max-width: 600px) {
  .sp {
    display: block;
  }
}

img {
  margin: 0 auto;
  text-align: center;
}

/*************header*************/
header .mv {
  margin: 80px auto 70px;
}

@media (max-width: 600px) {
  header .mv {
    margin: 7vw auto 14vw;
  }
}

header .mv .sub_ttl {
  opacity: 0;
  -webkit-animation-name: bottom_fadeIn;
          animation-name: bottom_fadeIn;
  -webkit-animation-duration: 1s;
          animation-duration: 1s;
  -webkit-animation-timing-function: linear;
          animation-timing-function: linear;
  -webkit-animation-delay: 0;
          animation-delay: 0;
  -webkit-animation-fill-mode: forwards;
          animation-fill-mode: forwards;
}

header .mv .sub_ttl img {
  margin: 0 auto 10px;
}

@media (max-width: 600px) {
  header .mv .sub_ttl img {
    width: 100%;
  }
}

header .mv .item {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin: 0 auto;
  width: 1010px;
}

@media (max-width: 600px) {
  header .mv .item {
    width: 100%;
  }
}

header .mv .item > img {
  margin: 0;
  opacity: 0;
  -webkit-animation-name: fadeIn;
          animation-name: fadeIn;
  -webkit-animation-duration: 1.5s;
          animation-duration: 1.5s;
  -webkit-animation-timing-function: linear;
          animation-timing-function: linear;
  -webkit-animation-delay: 1.25s;
          animation-delay: 1.25s;
  -webkit-animation-fill-mode: forwards;
          animation-fill-mode: forwards;
}

@media (max-width: 600px) {
  header .mv .item > img {
    opacity: 1;
    -webkit-animation: none;
            animation: none;
    width: 100%;
  }
}

header .mv .item > img.bottle {
  position: absolute;
  top: 33vw;
  left: 6.5vw;
  width: 34vw;
}

header .mv .item h1 {
  opacity: 0;
  -webkit-animation-name: fadeIn;
          animation-name: fadeIn;
  -webkit-animation-duration: 2s;
          animation-duration: 2s;
  -webkit-animation-timing-function: linear;
          animation-timing-function: linear;
  -webkit-animation-delay: 1.75s;
          animation-delay: 1.75s;
  -webkit-animation-fill-mode: forwards;
          animation-fill-mode: forwards;
}

@media (max-width: 600px) {
  header .mv .item h1 {
    -webkit-animation-delay: 1.25s;
            animation-delay: 1.25s;
    width: 100%;
  }
}

@media (max-width: 600px) {
  header .mv .item h1 img {
    width: 95%;
  }
}

header .period {
  margin-bottom: 60px;
  padding: 20px 0 10px;
  text-align: center;
  background-color: #f2e374;
}

@media (max-width: 600px) {
  header .period {
    margin-bottom: 10vw;
    padding: 0;
    background-color: transparent;
  }
  header .period img {
    width: 100%;
  }
}

@-webkit-keyframes bottom_fadeIn {
  0% {
    -webkit-transform: translate(0, 20px);
            transform: translate(0, 20px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translate(0, 0);
            transform: translate(0, 0);
    opacity: 1;
  }
}

@keyframes bottom_fadeIn {
  0% {
    -webkit-transform: translate(0, 20px);
            transform: translate(0, 20px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translate(0, 0);
            transform: translate(0, 0);
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/*************main_cont*************/
.main_cont .present_cont {
  margin-bottom: 40px;
}

@media (max-width: 600px) {
  .main_cont .present_cont {
    margin-bottom: 9vw;
  }
  .main_cont .present_cont img {
    width: 100%;
  }
}

.main_cont .camp_cont h2 {
  margin-bottom: 20px;
}

@media (max-width: 600px) {
  .main_cont .camp_cont h2 {
    margin-bottom: 5vw;
  }
  .main_cont .camp_cont h2 img {
    width: 100%;
  }
}

.main_cont .camp_cont .camp_how {
  margin: 0 auto 50px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  width: 1020px;
}

@media (max-width: 600px) {
  .main_cont .camp_cont .camp_how {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    width: 80%;
  }
}

.main_cont .camp_cont .camp_how li {
  position: relative;
  width: 100%;
}

@media (max-width: 600px) {
  .main_cont .camp_cont .camp_how li img {
    width: 100%;
  }
}

.main_cont .camp_cont .camp_how li a {
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  bottom: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 416px;
  font-size: 20px;
  font-weight: bold;
  color: #000;
}

@media (max-width: 600px) {
  .main_cont .camp_cont .camp_how li a {
    width: 100%;
    bottom: 8vw;
  }
}

.main_cont .camp_cont .camp_how li a span {
  position: relative;
}

.main_cont .camp_cont .camp_how li a span::before {
  content: '';
  position: absolute;
  top: 50%;
  left: -25px;
  width: 14px;
  height: 17px;
  background-image: url("./assets/img/btn_arrow.png");
  background-repeat: no-repeat;
  background-size: contain;
  -webkit-transform: translate(0, -50%);
          transform: translate(0, -50%);
}

.main_cont .camp_cont .camp_how li a:hover {
  -webkit-box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);
          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);
}

.main_cont .find_cont {
  padding: 30px 0 50px;
  -webkit-box-shadow: 0 -5px 10px 0 rgba(0, 0, 0, 0.75);
          box-shadow: 0 -5px 10px 0 rgba(0, 0, 0, 0.75);
  background: #d49b00;
  /* Old browsers */
  /* FF3.6-15 */
  /* Chrome10-25,Safari5.1-6 */
  background: -webkit-gradient(linear, left top, right top, from(#d49b00), color-stop(16%, #b68300), color-stop(32%, #e4c452), color-stop(50%, #e3de8d), color-stop(71%, #e4cd5c), color-stop(86%, #d5b031), to(#d5ac0e));
  background: linear-gradient(to right, #d49b00 0%, #b68300 16%, #e4c452 32%, #e3de8d 50%, #e4cd5c 71%, #d5b031 86%, #d5ac0e 100%);
  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#d49b00', endColorstr='#d5ac0e',GradientType=1 );
  /* IE6-9 */
}

@media (max-width: 600px) {
  .main_cont .find_cont {
    padding: 5vw 0;
    background: #d49b00;
    /* Old browsers */
    /* FF3.6-15 */
    /* Chrome10-25,Safari5.1-6 */
    background: -webkit-gradient(linear, left top, right top, from(#d49b00), color-stop(49%, #fff3bf), to(#d5b031));
    background: linear-gradient(to right, #d49b00 0%, #fff3bf 49%, #d5b031 100%);
    /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#d49b00', endColorstr='#d5b031',GradientType=1 );
    /* IE6-9 */
  }
}

.main_cont .find_cont .ttl {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin-bottom: 30px;
}

@media (max-width: 600px) {
  .main_cont .find_cont .ttl {
    margin-bottom: 0;
  }
}

.main_cont .find_cont .ttl h2 {
  margin: 0 auto;
  width: 578px;
  position: relative;
  text-align: center;
  min-width: 578px;
}

@media (max-width: 600px) {
  .main_cont .find_cont .ttl h2 {
    width: 100%;
    min-width: auto;
  }
}

.main_cont .find_cont .ttl h2 img {
  margin: 0 auto;
  padding: 0 50px;
  -webkit-box-sizing: content-box;
          box-sizing: content-box;
  position: relative;
  z-index: 2;
  width: 472px;
  height: auto;
}

@media (max-width: 600px) {
  .main_cont .find_cont .ttl h2 img {
    padding: 0;
    width: 100%;
  }
}

.main_cont .find_cont .ttl h2:nth-of-type(2) {
  display: none;
}

.main_cont .find_cont .ttl .border {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 2px;
  background-color: #ac1f24;
}

.main_cont .find_cont .ttl .border::after {
  content: '';
  position: absolute;
  z-index: 2;
  left: 0;
  bottom: 6px;
  width: 100%;
  height: 2px;
  background-color: #ac1f24;
}

.main_cont .find_cont .ttl.q h2:nth-of-type(1) {
  display: none;
}

.main_cont .find_cont .ttl.q h2:nth-of-type(2) {
  display: block;
  min-width: 826px;
}

@media (max-width: 600px) {
  .main_cont .find_cont .ttl.q h2:nth-of-type(2) {
    min-width: 100%;
    width: 100%;
  }
}

.main_cont .find_cont .ttl.q h2:nth-of-type(2) img {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 0;
  min-width: 726px;
}

@media (max-width: 600px) {
  .main_cont .find_cont .ttl.q h2:nth-of-type(2) img {
    min-width: 100%;
    width: 100%;
  }
}

.main_cont .find_cont .situation_ttl {
  margin-bottom: 30px;
  padding: 14px;
  background-color: #ac1f24;
}

.main_cont .find_cont .situation_ttl img {
  margin: 0 auto;
}

.main_cont .find_cont .situation_ttl.q {
  display: none;
}

@media (max-width: 600px) {
  .main_cont .find_cont .situation_ttl {
    margin-bottom: 0;
    padding: 0;
    background: transparent;
  }
  .main_cont .find_cont .situation_ttl img {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .opening {
    position: relative;
  }
}

.main_cont .find_cont .check_cont .opening.q {
  display: none;
}

.main_cont .find_cont .check_cont .opening .bg {
  margin: 0 auto;
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .opening .bg {
    width: 100%;
  }
  .main_cont .find_cont .check_cont .opening .bg img {
    width: 100%;
  }
}

.main_cont .find_cont .check_cont .opening .btn {
  cursor: pointer;
  margin: -110px auto 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 574px;
  height: 92px;
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .opening .btn {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 17vw;
    margin: 0 auto;
    width: 78vw;
    height: 12.5vw;
    font-size: 4vw;
  }
  .main_cont .find_cont .check_cont .opening .btn img {
    width: 100%;
  }
}

.main_cont .find_cont .check_cont .opening .btn:hover {
  opacity: .8;
}

.main_cont .find_cont .check_cont .question {
  margin: 0 auto 20px;
  width: 1040px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  color: #0a3c8c;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  line-height: 1.6;
  /* ゴシック体指定 */
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", HelveticaNeue, "Segoe UI", "游ゴシック体", YuGothic, "Yu Gothic M", "游ゴシック Medium", "Yu Gothic Medium", "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN W3", HiraKakuProN-W3, "ヒラギノ角ゴ ProN", "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
}

@media all and (-ms-high-contrast: none) {
  .main_cont .find_cont .check_cont .question {
    font-family: "メイリオ",Meiryo,"游ゴシック",YuGothic,"ヒラギノ角ゴ Pro W3","Hiragino Kaku Gothic Pro","ＭＳ Ｐゴシック","MS PGothic",sans-serif !important;
  }
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .question {
    margin-top: 20px;
    width: 100%;
  }
}

.main_cont .find_cont .check_cont .question .q_btn {
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-transition: .2s ease-in-out;
  transition: .2s ease-in-out;
}

.main_cont .find_cont .check_cont .question .q_btn.pc {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .question .q_btn.pc {
    display: none;
  }
}

.main_cont .find_cont .check_cont .question.q2 {
  display: flex;
}

.main_cont .find_cont .check_cont .question .q_btn.sp {
  display: none;
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .question .q_btn.sp {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
}

.main_cont .find_cont .check_cont .question .q_btn:hover {
  opacity: .95;
}

.main_cont .find_cont .check_cont .question.q2 .q_btn {
  width: 495px;
  height: 238px;
  background-image: url("./assets/img/pc/q2_off.png");
  background-repeat: no-repeat;
  background-size: contain;
}

.main_cont .find_cont .check_cont .question.q2 .q_btn:hover {
  background-image: url("./assets/img/pc/q2_on.png");
  color: #fff;
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .question.q2 .q_btn:active {
    color: #00f;
    background-image: url("./assets/img/pc/q2_off.png");
  }
}

.main_cont .find_cont .check_cont .question.q3 {
  display: flex;
}

.main_cont .find_cont .check_cont .question.q3 .q_btn {
  width: 330px;
  height: 238px;
  background-image: url("./assets/img/pc/q3_off.png");
  background-repeat: no-repeat;
  background-size: contain;
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .question.q3 .q_btn {
    width: 100%;
  }
}

.main_cont .find_cont .check_cont .question.q3 .q_btn:hover {
  background-image: url("./assets/img/pc/q3_on.png");
  color: #fff;
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .question.q3 .q_btn:active {
    color: #00f;
    background-image: url("./assets/img/pc/q3_off.png");
  }
}

.main_cont .find_cont .check_cont .question.q4 {
  display: flex;
}

.main_cont .find_cont .check_cont .question.q4 .q_btn {
  margin-bottom: 32px;
  width: 500px;
  height: 100px;
  background-image: url("./assets/img/pc/q4_off.png");
  background-repeat: no-repeat;
  background-size: contain;
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .question.q4 .q_btn {
    width: 100%;
  }
}

.main_cont .find_cont .check_cont .question.q4 .q_btn:hover {
  background-image: url("./assets/img/pc/q4_on.png");
  color: #fff;
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .question.q4 .q_btn:hover {
    color: #00f;
    background-image: url("./assets/img/pc/q4_off.png");
  }
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .question .q_btn {
    margin: 0 auto 5vw !important;
    width: 80vw !important;
    height: 17vw !important;
    background-image: url("./assets/img/pc/q4_off.png") !important;
    font-size: 4.2vw !important;
  }
  .main_cont .find_cont .check_cont .question .q_btn:hover {
    color: #0a3c8c !important;
    /*
    background-image: url("./assets/img/pc/q4_on.png") !important;
    color: #fff !important;
    */
  }
}

.main_cont .find_cont .check_cont .bottom_border {
  margin-top: 60px;
  position: relative;
  width: 100%;
  height: 2px;
  background-color: #ac1f24;
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .bottom_border {
    height: 1px;
  }
}

.main_cont .find_cont .check_cont .bottom_border::after {
  content: '';
  position: absolute;
  z-index: 2;
  left: 0;
  bottom: 6px;
  width: 100%;
  height: 2px;
  background-color: #ac1f24;
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .bottom_border::after {
    height: 1px;
  }
}

@media (max-width: 600px) {
  .main_cont .find_cont .check_cont .bottom_border {
    margin-top: 5vw;
  }
}

.main_cont .detail_cont {
  margin-bottom: 90px;
  text-align: center;
}

@media (max-width: 600px) {
  .main_cont .detail_cont {
    margin-bottom: 10vw;
  }
}

.main_cont .detail_cont h2 {
  margin: 70px auto;
}

@media (max-width: 600px) {
  .main_cont .detail_cont h2 {
    margin: 9vw auto;
  }
}

.main_cont .detail_cont h2 img {
  width: 257px;
}

@media (max-width: 600px) {
  .main_cont .detail_cont h2 img {
    width: 36vw;
  }
}

.main_cont .detail_cont .present_detail {
  position: relative;
  margin: 0 auto;
  width: 1062px;
  height: 852px;
  background-image: url("./assets/img/pc/present_detail_bg.png");
  background-repeat: no-repeat;
  background-size: contain;
  /* ゴシック体指定 */
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", HelveticaNeue, "Segoe UI", "游ゴシック体", YuGothic, "Yu Gothic M", "游ゴシック Medium", "Yu Gothic Medium", "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN W3", HiraKakuProN-W3, "ヒラギノ角ゴ ProN", "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
}

@media (max-width: 600px) {
  .main_cont .detail_cont .present_detail {
    width: 100%;
    height: 270vw;
    background-image: url("./assets/img/sp/present_detail_bg.png");
  }
}

.main_cont .detail_cont .present_detail h3 {
  position: absolute;
  display: inline-block;
  top: 98px;
  left: 448px;
}

@media (max-width: 600px) {
  .main_cont .detail_cont .present_detail h3 {
    top: 46vw;
    margin: 0 auto;
    right: 0;
    left: 0;
    width: 60vw;
  }
  .main_cont .detail_cont .present_detail h3 img {
    width: 100%;
  }
}

.main_cont .detail_cont .present_detail .lead {
  position: absolute;
  display: inline-block;
  top: 160px;
  left: 453px;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.6;
  text-align: left;
}

@media (max-width: 600px) {
  .main_cont .detail_cont .present_detail .lead {
    top: 58vw;
    margin: 0 auto;
    right: 0;
    left: 0;
    width: 80vw;
    font-size: 3.5vw;
    line-height: 1.6;
  }
}

.main_cont .detail_cont .present_detail .lead .l {
  font-size: 24px;
}

.main_cont .detail_cont .present_detail .lead .gr {
  display: inline-block;
  margin-top: .5em;
  font-size: 15px;
  color: #999999;
  margin-left: 1em;
  text-indent: -1em;
}

@media (max-width: 600px) {
  .main_cont .detail_cont .present_detail .lead .l {
    font-size: 4vw;
  }
  .main_cont .detail_cont .present_detail .lead .gr {
    font-size: 3vw;
  }
}

.main_cont .detail_cont .present_detail .att {
  position: absolute;
  top: 330px;
  left: 453px;
  display: inline-block;
  margin-top: .5em;
  font-size: 15px;
  font-weight: bold;
  color: #999999;
  text-align: left;
  max-width: 535px;
  line-height: 1.6;
}

.main_cont .detail_cont .present_detail .att li {
  margin-left: 1em;
  text-indent: -1em;
}

@media (max-width: 1024px) {
  .main_cont .detail_cont .present_detail .att {
    font-size: 14px;
  }
}

@media (max-width: 600px) {
  .main_cont .detail_cont .present_detail .att {
    top: 99vw;
    margin: 0 auto;
    right: 0;
    left: 0;
    width: 80vw;
    font-size: 2vw;
    line-height: 1.6;
  }
}

.main_cont .detail_cont .present_detail .spec {
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 20px;
  width: 414px;
  top: 234px;
  left: 453px;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  line-height: 1.6;
  background-color: #f2f2f2;
}

@media (max-width: 600px) {
  .main_cont .detail_cont .present_detail .spec {
    top: 80vw;
    margin: 0 auto;
    right: 0;
    left: 0;
    padding: 10px;
    width: 70vw;
    font-size: 3vw;
    line-height: 1.6;
    background-color: #f2f2f2;
    text-align: center;
  }
}

.main_cont .detail_cont .present_detail div:nth-child(2) h3 {
  position: absolute;
  display: inline-block;
  top: 477px;
  left: 448px;
}

@media (max-width: 600px) {
  .main_cont .detail_cont .present_detail div:nth-child(2) h3 {
    top: 191vw;
    margin: 0 auto;
    right: 0;
    left: 0;
    width: 71vw;
  }
  .main_cont .detail_cont .present_detail div:nth-child(2) h3 img {
    width: 100%;
  }
}

.main_cont .detail_cont .present_detail div:nth-child(2) .lead {
  position: absolute;
  display: inline-block;
  top: 573px;
  left: 453px;
  font-size: 18px;
  font-weight: bold;
  width: 500px;
  text-align: left;
  line-height: 1.6;
}

.main_cont .detail_cont .present_detail div:nth-child(2) .lead .l {
  font-size: 24px;
}

.main_cont .detail_cont .present_detail div:nth-child(2) .lead .gr {
  display: inline-block;
  margin-top: .5em;
  font-size: 15px;
  color: #999999;
  margin-left: 1em;
}

@media (max-width: 600px) {
  .main_cont .detail_cont .present_detail div:nth-child(2) .lead {
    top: 208vw;
    margin: 0 auto;
    right: 0;
    left: 0;
    width: 80vw;
    font-size: 3.5vw;
    line-height: 1.6;
  }
  .main_cont .detail_cont .present_detail div:nth-child(2) .lead .l {
    font-size: 4vw;
  }
  .main_cont .detail_cont .present_detail div:nth-child(2) .lead .gr {
    font-size: 3vw;
  }
}

.main_cont .detail_cont .present_detail div:nth-child(2) .spec {
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 20px;
  width: 414px;
  top: 653px;
  left: 453px;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  line-height: 1.6;
  background-color: #f2f2f2;
}

@media (max-width: 600px) {
  .main_cont .detail_cont .present_detail div:nth-child(2) .spec {
    top: 145vw;
    margin: 0 auto;
    right: 0;
    left: 0;
    padding: 10px;
    width: 70vw;
    font-size: 3vw;
    line-height: 1.6;
    background-color: #f2f2f2;
    text-align: center;
  }
}

.main_cont .offer_cont {
  margin: 0 auto 60px;
  width: 1000px;
  padding: 40px;
  background-color: #fff;
  /* ゴシック体指定 */
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", HelveticaNeue, "Segoe UI", "游ゴシック体", YuGothic, "Yu Gothic M", "游ゴシック Medium", "Yu Gothic Medium", "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN W3", HiraKakuProN-W3, "ヒラギノ角ゴ ProN", "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
}

@media (max-width: 600px) {
  .main_cont .offer_cont {
    margin-bottom: 10vw;
    height: auto;
    width: 100%;
    padding: 1.5em;
  }
}

.main_cont .offer_cont h4 {
  margin-bottom: 40px;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  text-decoration: underline;
}

@media (max-width: 600px) {
  .main_cont .offer_cont h4 {
    margin-bottom: 1em;
    font-size: 4vw;
  }
}

.main_cont .offer_cont dl {
  margin-bottom: 2em;
  line-height: 1.6;
}

@media (max-width: 600px) {
  .main_cont .offer_cont dl {
    margin-bottom: 1em;
  }
}

.main_cont .offer_cont dl:last-child {
  margin-bottom: 0;
}

.main_cont .offer_cont dl dt {
  margin-bottom: .5em;
  font-size: 16px;
  font-weight: bold;
}

@media (max-width: 600px) {
  .main_cont .offer_cont dl dt {
    font-size: 3.5vw;
  }
}

.main_cont .offer_cont dl dd {
  font-size: 13px;
  font-weight: bold;
}

@media (max-width: 600px) {
  .main_cont .offer_cont dl dd {
    font-size: 3vw;
  }
}

.main_cont .offer_cont dl dd ul li {
  margin-left: 1em;
  text-indent: -1em;
}

.main_cont .link_cont {
  margin: 0 auto 60px;
  width: 880px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

@media (max-width: 600px) {
  .main_cont .link_cont {
    width: 70vw;
  }
}

.main_cont .link_cont.back {
  display: none;
  margin: 0 auto;
}

.main_cont .link_cont a {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 400px;
  height: 60px;
  background-image: url("./assets/img/pc/link_btn.png");
  background-repeat: no-repeat;
  background-size: contain;
  color: #fff;
  font-size: 19px;
}

@media (max-width: 600px) {
  .main_cont .link_cont a {
    margin-bottom: 5vw;
    width: 100%;
    height: 10.7vw;
    font-size: 3.5vw;
  }
}

.main_cont .link_cont a:hover {
  cursor: pointer;
}

.main_cont .link_cont a span {
  position: relative;
}

.main_cont .link_cont a span:before {
  content: '';
  position: absolute;
  top: 50%;
  left: -25px;
  width: 14px;
  height: 17px;
  background-image: url("./assets/img/btn_arrow.png");
  background-repeat: no-repeat;
  background-size: contain;
  -webkit-transform: translate(0, -50%);
          transform: translate(0, -50%);
}

.main_cont .link_cont a span.back:before {
  -webkit-transform: translate(0, -50%) rotate(180deg);
          transform: translate(0, -50%) rotate(180deg);
}

.main_cont .link_cont a:hover {
  opacity: .8;
}

.main_cont .modal_cont {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 110vh;
  background-color: rgba(10, 60, 140, 0.8);
}

.main_cont .modal_cont .find_cont {
  overflow-y: scroll;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100vh;
}

@media (max-width: 600px) {
  .main_cont .modal_cont .find_cont {
    top: 70px;
    height: 80vh;
    max-height: 600px;
  }
}

.main_cont .modal_cont .find_cont .result_cont {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  width: 1000px;
  color: #000;
  position: relative;
  font-family: "TBUD明朝 H", TBUDMincho H !important;
}

@media (max-width: 600px) {
  .main_cont .modal_cont .find_cont .result_cont {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }
}

.main_cont .modal_cont .find_cont .result_cont:before {
  content: '';
  position: absolute;
  z-index: 1;
  right: -40px;
  top: 0;
  width: 160px;
  height: 103px;
  background-image: url("./assets/img/pc/result_deco01.png");
  background-repeat: no-repeat;
  background-size: contain;
}

@media (max-width: 600px) {
  .main_cont .modal_cont .find_cont .result_cont:before {
    background-image: url("./assets/img/sp/result_deco.png");
    width: 70vw;
    height: 20vw;
    margin: 0 auto;
    right: 0;
    left: 0;
    top: 20vw;
  }
}

.main_cont .modal_cont .find_cont .result_cont:after {
  content: '';
  position: absolute;
  z-index: 1;
  left: -40px;
  bottom: 0;
  width: 180px;
  height: 108px;
  background-image: url("./assets/img/pc/result_deco02.png");
  background-repeat: no-repeat;
  background-size: contain;
}

@media (max-width: 600px) {
  .main_cont .modal_cont .find_cont .result_cont:after {
    display: none;
  }
}

.main_cont .modal_cont .find_cont .result_cont .img_cont {
  position: relative;
  z-index: 2;
}

@media (max-width: 600px) {
  .main_cont .modal_cont .find_cont .result_cont .img_cont {
    width: 100%;
    text-align: center;
  }
  .main_cont .modal_cont .find_cont .result_cont .img_cont img {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .main_cont .modal_cont .find_cont .result_cont .txt_cont {
    margin: 10px auto 0;
  }
}

.main_cont .modal_cont .find_cont .result_cont .genre {
  margin-left: 40px;
  margin-bottom: 15px;
  display: inline-block;
}

@media all and (-ms-high-contrast: none) {
  .main_cont .modal_cont .find_cont .result_cont .genre {
    font-family: "メイリオ",Meiryo,"游ゴシック",YuGothic,"ヒラギノ角ゴ Pro W3","Hiragino Kaku Gothic Pro","ＭＳ Ｐゴシック","MS PGothic",sans-serif !important;
  }
}

@media (max-width: 600px) {
  .main_cont .modal_cont .find_cont .result_cont .genre {
    margin-left: 0;
    display: none;
  }
}

.main_cont .modal_cont .find_cont .result_cont .result_ttl {
  padding: 0 40px;
  line-height: 1.6;
  text-align: left;
}

@media (max-width: 600px) {
  .main_cont .modal_cont .find_cont .result_cont .result_ttl {
    padding: 0;
    margin: 0 auto;
    text-align: center;
    width: 80vw;
  }
}

.main_cont .modal_cont .find_cont .result_cont .result_ttl dt {
  font-size: 25px;
}

@media (max-width: 600px) {
  .main_cont .modal_cont .find_cont .result_cont .result_ttl dt {
    font-size: 4vw;
  }
}

.main_cont .modal_cont .find_cont .result_cont .result_ttl dd {
  font-size: 38px;
  font-weight: bold;
}

@media (max-width: 600px) {
  .main_cont .modal_cont .find_cont .result_cont .result_ttl dd {
    font-size: 6vw;
  }
}

.main_cont .modal_cont .find_cont .result_cont .lead {
  margin-bottom: 20px;
  line-height: 1.6;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
}

.main_cont .modal_cont .find_cont .result_cont .lead img {
  width: 100%;
}

@media (max-width: 600px) {
  .main_cont .modal_cont .find_cont .result_cont .lead {
    font-size: 3vw;
    margin: 0 auto;
    width: 80vw;
  }
}

.main_cont .modal_cont .find_cont .result_cont .lead span {
  display: block;
  padding: 0 40px;
}

.main_cont .modal_cont .find_cont .result_cont .lead .merit {
  font-size: 14px;
  text-align: center;
}

@media (max-width: 600px) {
  .main_cont .modal_cont .find_cont .result_cont .lead .merit {
    font-size: 2.5vw;
  }
}

.main_cont .modal_cont .find_cont .result_cont .result_vote {
  display: block;
  margin: 0 auto;
  text-align: center;
}

@media (max-width: 600px) {
  .main_cont .modal_cont .find_cont .result_cont .result_vote img {
    width: 70vw;
  }
}

.main_cont .modal_cont .close_btn {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 5px;
}

@media all and (-ms-high-contrast: none) {
  body {
    font-family: "メイリオ",Meiryo,"游ゴシック",YuGothic,"ヒラギノ角ゴ Pro W3","Hiragino Kaku Gothic Pro","ＭＳ Ｐゴシック","MS PGothic",sans-serif !important;
  }
}

.lineup_cont {
  padding: 100px 0 85px;
  background: #041534;
  /* Old browsers */
  /* FF3.6-15 */
  /* Chrome10-25,Safari5.1-6 */
  background: -webkit-gradient(linear, left top, right top, from(#041534), color-stop(50%, #051a40), to(#041534));
  background: linear-gradient(to right, #041534 0%, #051a40 50%, #041534 100%);
  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#041534', endColorstr='#041534',GradientType=1 );
  /* IE6-9 */
}

@media (max-width: 600px) {
  .lineup_cont {
    padding: 10vw 0 8.5vw;
  }
}

.lineup_cont h2 img {
  margin: 0 auto 90px;
}

@media (max-width: 600px) {
  .lineup_cont h2 img {
    width: 100%;
    margin-bottom: 10vw;
  }
}

.lineup_cont .lineup_list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin: 0 auto;
  width: 1000px;
}

@media (max-width: 600px) {
  .lineup_cont .lineup_list {
    width: 100%;
  }
}

.lineup_cont .lineup_list li {
  position: relative;
  margin-bottom: 30px;
  width: 234px;
}

@media (max-width: 600px) {
  .lineup_cont .lineup_list li {
    margin-bottom: 2.7vw;
    width: 48%;
  }
}

.lineup_cont .lineup_list li img {
  width: 100%;
}

.lineup_cont .lineup_list li dl {
  position: absolute;
  top: 190px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  padding: 10px 11px;
  text-align: center;
  color: #fff;
  width: 100%;
  height: 210px;
}

@media (max-width: 600px) {
  .lineup_cont .lineup_list li dl {
    top: 35vw;
    height: 42vw;
    padding: 1.5vw;
  }
}

.lineup_cont .lineup_list li dl .no {
  text-align: center;
  font-size: 50px;
}

@media (max-width: 600px) {
  .lineup_cont .lineup_list li dl .no {
    font-size: 9vw;
  }
}

.lineup_cont .lineup_list li dl .desc {
  padding: 0 0 5px;
  font-size: 13px;
  font-weight: bold;
  line-height: 1.42;
  letter-spacing: -0.08em;
  /* ゴシック体指定 */
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", HelveticaNeue, "Segoe UI", "游ゴシック体", YuGothic, "Yu Gothic M", "游ゴシック Medium", "Yu Gothic Medium", "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN W3", HiraKakuProN-W3, "ヒラギノ角ゴ ProN", "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
}

@media (max-width: 1024px) {
  .lineup_cont .lineup_list li dl .desc {
    font-size: 12px;
    letter-spacing: -0.1em;
  }
}

@media all and (-ms-high-contrast: none) {
  .lineup_cont .lineup_list li dl .desc {
    min-height: 41px;
  }
}

@media (max-width: 600px) {
  .lineup_cont .lineup_list li dl .desc {
    font-size: 2.6vw;
  }
}

.lineup_cont .lineup_list li dl .desc sub {
  font-size: 10px;
  vertical-align: bottom;
}

.lineup_cont .lineup_list li dl .ttl {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 100%;
  color: #000;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.1;
  font-family: TBUD明朝 H,TBUDMincho H!important;
}

@media (max-width: 600px) {
  .lineup_cont .lineup_list li dl .ttl {
    font-size: 3vw;
  }
}

.lineup_cont .lineup_list li dl .ttl.l1 {
  height: 40px;
  background-image: url("./assets/img/lineup_re_l1.png");
  background-repeat: no-repeat;
  background-size: contain;
}

@media all and (-ms-high-contrast: none) {
  .lineup_cont .lineup_list li dl .ttl.l1 {
    min-height: 54px;
  }
  .lineup_cont .lineup_list li dl .ttl.l1 span {
    -webkit-transform: scale(0.85, 1) translate(0, -9px);
            transform: scale(0.85, 1) translate(0, -9px);
  }
}

@media (max-width: 600px) {
  .lineup_cont .lineup_list li dl .ttl.l1 {
    height: 8vw;
  }
}

.lineup_cont .lineup_list li dl .ttl.l2 {
  height: 54px;
  background-image: url("./assets/img/lineup_re_l2.png");
  background-repeat: no-repeat;
  background-size: contain;
}

@media all and (-ms-high-contrast: none) {
  .lineup_cont .lineup_list li dl .ttl.l2 {
    min-height: 54px;
  }
}

@media (max-width: 600px) {
  .lineup_cont .lineup_list li dl .ttl.l2 {
    height: 11vw;
  }
}

.lineup_cont .lineup_list li dl .ttl span {
  display: block;
  -webkit-transform: scale(0.85, 1) translate(0, -3px);
          transform: scale(0.85, 1) translate(0, -3px);
  font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,HelveticaNeue,Segoe UI,游ゴシック体,YuGothic,Yu Gothic M,游ゴシック Medium,Yu Gothic Medium,ヒラギノ角ゴ ProN W3,Hiragino Kaku Gothic ProN W3,HiraKakuProN-W3,ヒラギノ角ゴ ProN,Hiragino Kaku Gothic ProN,ヒラギノ角ゴ Pro,Hiragino Kaku Gothic Pro,メイリオ,Meiryo,Osaka,ＭＳ Ｐゴシック,MS PGothic,sans-serif;
  font-weight: bold;
}

.lineup_cont .lineup_list li dl .ttl span sub {
  font-size: 8px;
  vertical-align: baseline;
}

.lineup_cont .lineup_list li dl .vote_btn:hover {
  -webkit-transform: scale(1.05);
          transform: scale(1.05);
}

#form .lineup_cont {
  padding: 0 !important;
  background: none !important;
}

#form .lineup_cont .link_cont {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin-bottom: 30px;
}

#form .lineup_cont .link_cont a {
  background-color: #fff;
  color: #00f;
  background-image: none;
  font-size: 14px;
  max-width: 300px;
}

#form .lineup_cont .lead {
  margin-bottom: 20px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  /* ゴシック体指定 */
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", HelveticaNeue, "Segoe UI", "游ゴシック体", YuGothic, "Yu Gothic M", "游ゴシック Medium", "Yu Gothic Medium", "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN W3", HiraKakuProN-W3, "ヒラギノ角ゴ ProN", "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif !important;
}

#form .lineup_cont .lineup_list {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

#form .lineup_cont .lineup_list li dl {
  width: 100%;
  padding-bottom: 30px;
}

#form .mv {
  margin-bottom: 30px;
}

#form .mv .sub_ttl {
  opacity: 1;
  -webkit-animation: none;
          animation: none;
}

#form .mv h1 {
  opacity: 1;
  -webkit-animation: none;
          animation: none;
}

#form .mv .item img {
  opacity: 1;
  -webkit-animation: none;
          animation: none;
}

@media (max-width: 600px) {
  #form .mv .item .bottle {
    display: none;
  }
}

#form .form_cont {
  margin: 0 auto 80px;
  width: 1000px;
}

#form .form_cont h2 {
  position: relative;
  margin-bottom: 1em;
  padding-bottom: .5em;
  font-size: 24px;
  color: #fff;
}

#form .form_cont h2:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -.5em;
  width: 100%;
  height: 2px;
  background: #d49b00;
  /* Old browsers */
  /* FF3.6-15 */
  /* Chrome10-25,Safari5.1-6 */
  background: -webkit-gradient(linear, left top, right top, from(#d49b00), color-stop(16%, #b68300), color-stop(32%, #e4c452), color-stop(50%, #e3de8d), color-stop(71%, #e4cd5c), color-stop(86%, #d5b031), to(#d5ac0e));
  background: linear-gradient(to right, #d49b00 0%, #b68300 16%, #e4c452 32%, #e3de8d 50%, #e4cd5c 71%, #d5b031 86%, #d5ac0e 100%);
  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#d49b00', endColorstr='#d5ac0e',GradientType=1 );
  /* IE6-9 */
}

#form .form_list {
  /* ゴシック体指定 */
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", HelveticaNeue, "Segoe UI", "游ゴシック体", YuGothic, "Yu Gothic M", "游ゴシック Medium", "Yu Gothic Medium", "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN W3", HiraKakuProN-W3, "ヒラギノ角ゴ ProN", "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
}

#form .form_list input, #form .form_list button, #form .form_list textarea, #form .form_list select {
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  border-radius: 0;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

#form .form_list dl {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin-bottom: 1em;
}

@media (max-width: 600px) {
  #form .form_list dl {
    margin-bottom: 2em;
  }
}

#form .form_list dl dt {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  width: 30%;
  font-size: 18px;
  color: #fff;
  line-height: 1.6;
}

@media (max-width: 600px) {
  #form .form_list dl dt {
    width: 100%;
    margin-bottom: 1em;
  }
}

#form .form_list dl dt.full {
  width: 100%;
  margin-bottom: 1em;
}

#form .form_list dl dt .must {
  margin-right: .5em;
  border-radius: 5px;
  padding: 5px 10px;
  background-color: #ba0021;
  font-size: 14px;
  min-width: 48px;
}

#form .form_list dl dt.choice {
  font-size: 16px;
}

#form .form_list dl dd {
  width: 69%;
}

@media (max-width: 600px) {
  #form .form_list dl dd {
    width: 100%;
  }
}

#form .form_list dl dd.full {
  width: 100%;
}

#form .form_list dl dd.full input + label {
  margin-bottom: 1em;
}

#form .form_list dl dd .txt {
  color: #fff;
  font-size: 16px;
  margin-right: .5em;
}

#form .form_list dl dd .btn {
  cursor: pointer;
  border-radius: 5px;
  padding: 10px;
  font-size: 16px;
  background-color: #b9b174;
}

#form .form_list dl dd .mb {
  margin-bottom: 1em;
}

#form .form_list dl dd input {
  padding: 10px;
  font-size: 16px;
  background-color: #fff;
  width: 100%;
}

#form .form_list dl dd input.half {
  margin-right: 1%;
  width: 49%;
}

#form .form_list dl dd input.half:last-child {
  margin-right: 0;
}

@media (max-width: 600px) {
  #form .form_list dl dd input.half {
    width: 45%;
  }
}

#form .form_list dl dd input.tri {
  width: 25%;
  margin-right: .5em;
}

@media (max-width: 600px) {
  #form .form_list dl dd input.tri {
    width: 22%;
  }
}

#form .form_list dl dd input[type="radio"] {
  display: none;
}

#form .form_list dl dd label {
  position: relative;
  display: inline-block;
  padding: 3px 3px 3px 20px;
  cursor: pointer;
  font-size: 16px;
  color: #fff;
  margin-right: 1em;
}

#form .form_list dl dd label::before {
  position: absolute;
  content: '';
  top: 50%;
  left: 0;
  width: 14px;
  height: 14px;
  margin-top: -8px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 100%;
}

#form .form_list dl dd input[type="radio"]:checked + label::after {
  position: absolute;
  content: '';
  top: 50%;
  left: 3px;
  width: 8px;
  height: 8px;
  margin-top: -5px;
  background: #ba0021;
  border-radius: 100%;
}

#form .form_list dl dd input[type="checkbox"] {
  display: none;
}

#form .form_list dl dd input[type="checkbox"] + label {
  position: relative;
  display: inline-block;
  padding: 3px 3px 3px 22px;
  cursor: pointer;
}

#form .form_list dl dd input[type="checkbox"] + label::before {
  position: absolute;
  content: '';
  top: 50%;
  left: 0;
  width: 14px;
  height: 14px;
  margin-top: -8px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 0;
}

#form .form_list dl dd input[type="checkbox"]:checked + label::after {
  position: absolute;
  content: '';
  top: 50%px;
  left: 3px;
  width: 13px;
  height: 7px;
  border-left: 3px solid #ba0021;
  border-bottom: 3px solid #ba0021;
  -webkit-transform: rotate(-45deg);
          transform: rotate(-45deg);
}

#form .form_list dl dd .select_cont {
  overflow: hidden;
  width: 50%;
  text-align: center;
}

#form .form_list dl dd .select_cont select {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  cursor: pointer;
  text-indent: 0.01px;
  text-overflow: ellipsis;
  border: none;
  outline: none;
  background: transparent;
  background-image: none;
  -webkit-box-shadow: none;
          box-shadow: none;
  -webkit-appearance: none;
  -moz-appearance: none;
       appearance: none;
}

#form .form_list dl dd .select_cont select::-ms-expand {
  display: none;
}

#form .form_list dl dd .select_cont {
  position: relative;
  background: #ffffff;
}

#form .form_list dl dd .select_cont::before {
  position: absolute;
  top: 0.8em;
  right: 0.8em;
  width: 0;
  height: 0;
  padding: 0;
  content: '';
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #000;
  pointer-events: none;
}

#form .form_list dl dd .select_cont select {
  padding: 8px 38px 8px 8px;
}

footer {
  padding: 20px 0;
  background-color: #072b61;
}

footer p {
  margin-bottom: 20px !important;
  line-height: 1.45;
  font-size: 12px;
  color: #fff;
  max-width: 600px;
  /* ゴシック体指定 */
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", HelveticaNeue, "Segoe UI", "游ゴシック体", YuGothic, "Yu Gothic M", "游ゴシック Medium", "Yu Gothic Medium", "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN W3", HiraKakuProN-W3, "ヒラギノ角ゴ ProN", "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
}

footer p:first-child {
  padding-left: 81px;
}

@media (max-width: 600px) {
  footer p:first-child {
    padding-left: 0;
  }
}

footer p:nth-child(2) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin-bottom: 0 !important;
}

footer p:nth-child(2) img {
  min-width: 61px;
  width: 61px;
  min-height: 34px;
  height: 34px;
  margin-right: 20px;
}

#confirm {
  color: #fff;
  /* ゴシック体指定 */
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", HelveticaNeue, "Segoe UI", "游ゴシック体", YuGothic, "Yu Gothic M", "游ゴシック Medium", "Yu Gothic Medium", "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN W3", HiraKakuProN-W3, "ヒラギノ角ゴ ProN", "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
}

@media all and (-ms-high-contrast: none) {
  .up {
    -webkit-transform: translate(0, -14px);
            transform: translate(0, -14px);
  }
  .down {
    -webkit-transform: translate(0, 8px);
            transform: translate(0, 8px);
  }
}
/*# sourceMappingURL=style.css.map */
</style>
